export default __webpack_public_path__ + "static/media/RyanMahoney.2af4b202.png";